import i18n from '@/plugins/i18n';
import { UrlPartInfo } from '../common/url-part-info';

export class Category {
    public id: number = 0;
    public businessId: number = 0;
    public name?: string;
    public isQuickNavigation: boolean = false;
    public isQuickNavigationInherited: boolean = false;
    public parentCategoryId: number | null = null;
    public level: number = 0;
    public subcategories: Category[] = [];
    public selected: boolean = false;
    public optgroup: boolean = false;
    public disabled: boolean = false;
    public position: number = 0;
    public imageUrl: string | null = null;
    public hasAtLeastOnePublishedReference: number = 0;
    public publicCanonicalUrls: UrlPartInfo[] = [];

    get value(): number | undefined {
        return this.id;
    }

    get text(): string | undefined {
        return this.name;
    }

    get publicCanonicalUrl(): string | undefined {
        return this.publicCanonicalUrls && this.publicCanonicalUrls.length > 0 ? this.publicCanonicalUrls.find(url => url.culture === i18n.locale)!.urlForEntitiesWithSlug : undefined;
    }

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json, {
            subcategories: json.subcategories ? json.subcategories.map((category: any) => new Category(category)) : [],
            publicCanonicalUrls: json.publicCanonicalUrls ? json.publicCanonicalUrls.map((url: any) => new UrlPartInfo(url)) : []
        });
    }

    public clone(): Category {
        const category: Category = new Category();

        category.id = this.id;
        category.businessId = this.businessId;
        category.name = this.name;
        category.isQuickNavigation = this.isQuickNavigation;
        category.isQuickNavigationInherited = this.isQuickNavigationInherited;
        category.parentCategoryId = this.parentCategoryId;
        category.level = this.level;
        category.optgroup = this.optgroup;
        category.disabled = this.disabled;
        category.position = this.position;
        category.imageUrl = this.imageUrl;
        category.hasAtLeastOnePublishedReference = this.hasAtLeastOnePublishedReference;
        category.publicCanonicalUrls.push(...this.publicCanonicalUrls.map(url => url.clone()));

        return category;
    }
}
